import request from "@/CommonDP/utils/request";
export default {
  // 列表
  queryFlowGroupList(enterpriseId) {
    return request.get(`/flow/queryFlowGroupList?enterpriseId=${enterpriseId}`);
  },
  // 修改
  updateFlowGroup(params) {
    return request.post(`/flow/updateFlowGroup`, params);
  },
  // 删除
  deleteStandardFrameFile(params) {
    return request.get("/flow/deleteFlowGroup", { params });
  },
  addFlowGroup(params) {
    return request.post("/flow/addFlowGroup", params);
  },
  addFlowDefinition(params) {
    return request.post("/flow/addFlowDefinition", params);
  },
  updateFlowDefinition(params, id) {
    return request.post("/flow/updateFlowDefinition?flowDefinitionId=" + id, params);
  },
  // 列表
  queryFlowDefinitionList(params) {
    return request.get("/flow/queryFlowDefinitionList", { params });
  },
  // 删除
  deleteCertainEval(evalID) {
    return request.post(`/CertainEval/deleteCertainEval?evalID=` + evalID);
  },
  // 流程名查阶段
  queryDefListByDefId(definitionId, prjId, formType) {
    return request.get(`/flow/queryDefListByDefId?definitionId=${definitionId}&prjId=${prjId}&formType=${formType}`);
  },
  // 获取项目角色
  queryRoleListFlow(enterpriseId) {
    return request.get(`/flow/queryRoleList?enterpriseId=${enterpriseId}`);
  },
  // 获取系统角色
  querySysRoleList(enterpriseId) {
    return request.get(`/flow/querySysRoleList?enterpriseId=${enterpriseId}`);
  },
  // 获取部门
  queryOrgList(enterpriseId, assigneeType) {
    return request.get(`/flow/queryOrgList?enterpriseId=${enterpriseId}&assigneeType=${assigneeType}`, { title: '数据读取中...' });
  },
  // 删除流程
  deleteFlowDefinition(id) {
    return request.post(`/flow/deleteFlowDefinition?id=` + id);
  },
  queryDefinitionCountSum(enterpriseId) {
    return request.post(`/flow/queryDefinitionCountSum?enterpriseId=${enterpriseId}`);
  },
  queryGroupInfoList(enterpriseId) {
    return request.get(`/flow/queryGroupInfoList?enterpriseId=${enterpriseId}`);
  },
  getUserListByDepId(depId) {
    return request.get(`/flow/getUserListByDepId?depId=` + depId);
  },
  // 获取部门 流程定义
  queryLeafOrgList(pDepId) {
    return request.get("/flow/queryLeafOrgList?pDepId=" + pDepId);
  },
  // 流程详情
  flowDefinitionDetail(id) {
    return request.get("/flow/flowDefinitionDetail?id=" + id);
  },
  hasStartedFlow(id) {
    return request.get("/flow/hasStartedFlow?flowDefinitionId=" + id);
  },
  initFlowDefinition(id) {
    return request.get("/flow/initFlowDefinition?groupId=" + id);
  },
  queryOrgListByKeyword(enterpriseId, keyword) {
    return request.get("/org/queryOrgListByKeyword?enterpriseId=" + enterpriseId + '&keyword=' + keyword, { title: "人员查询中..." });
  }
};
